import { addKeyToAccount } from 'flow/transactions/account';
import React, { useState } from 'react';
import { Button, Modal, Form, ModalHeader, ModalBody, ModalFooter, FormGroup, InputGroup, InputGroupAddon, Input, InputGroupText, Label } from 'reactstrap';

function AddKeyModal({modal, toggle, args}) {
    const [publicKey, setPublicKey] = useState('')
    const [weight, setWeight] = useState('')
    const [signatureAlgorithm, setSignatureAlgorithm] = useState('')
    const [hashType, setHashType] = useState('')

    const hndleAddKeySubmit = async (event) => {
        event.preventDefault();
        console.log(publicKey)
        await addKeyToAccount(publicKey.trim(), signatureAlgorithm, hashType, parseFloat(weight).toFixed(4))
        toggle()
      }

  return (
    <div>

      <Modal isOpen={modal} toggle={toggle} {...args}>
        <ModalHeader toggle={toggle}>Add New Key</ModalHeader>
        <ModalBody>
        <div className="text-center text-bold mb-4">
              <small>Add Key to Your Account</small>
            </div>
            <Form role="form">

              <FormGroup>
                    <Label for="publickey">
                      Public Key
                    </Label>
                    <Input
                    id="publickey"
                    placeholder="Address"
                    type="text"
                    value={publicKey}
                    onChange={(e) => setPublicKey(e.target.value)}
                    />
                </FormGroup>


              <FormGroup>
                    <Label for="weight">
                        Weight
                     </Label>
                    <Input
                    id="weight"
                    placeholder="1000"
                    step="0.01"
                    type="number"
                    value={weight}
                    onChange={(e) => setWeight(e.target.value)}
                  />
                </FormGroup>
            
              
              <FormGroup>
                    <Label for="signalgoid">
                     Signature Algorithm
                    </Label>
                    <Input
                    value={signatureAlgorithm}
                    id="signalgoid"
                    name="signalgo"
                    type="select"
                    onChange={(e) => {
                        console.log(e.target.value)
                        setSignatureAlgorithm(e.target.value)}}
                    >
                    <option value="ECDSA_P256">
                    ECDSA_P256
                    </option>
                    <option value="ECDSA_secp256k1">
                    ECDSA_secp256k1
                    </option>
                    
                    </Input>
                </FormGroup>
                <FormGroup>
                    <Label for="hashalgoid">
                     Hashing Algorithm
                    </Label>
                    <Input
                    value={hashType}
                    id="hashalgoid"
                    name="hashalgo"
                    type="select"
                    onChange={(e) => {
                        console.log(e.target.value)
                         setHashType(e.target.value)
                    }}
                    >
                    <option value="SHA3_256">
                    SHA3_256
                    </option>
                    <option value="SHA2_256">
                    SHA2_256
                    </option>
                    
                    </Input>
                </FormGroup>
            </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={hndleAddKeySubmit}>
            Add
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default AddKeyModal;